(function() { window.GUID_0da7474a_16ea_4fba_bdc2_14007eb827ae = { getGuid: function() { return "0da7474a-16ea-4fba-bdc2-14007eb827ae"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let OrderDirection;
        (function (OrderDirection) {
            OrderDirection[OrderDirection["Ascending"] = 0] = "Ascending";
            OrderDirection[OrderDirection["Descending"] = 1] = "Descending";
        })(OrderDirection = Enumeration.OrderDirection || (Enumeration.OrderDirection = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=OrderDirection.pre.js.map
